import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'shares.pageTitle',
    defaultMessage: 'Shares',
  },
  emptyTitle: {
    id: 'shares.emptyTitle',
    defaultMessage: 'No shares yet',
  },
  emptyDescription: {
    id: 'shares.emptyDescription',
    defaultMessage: 'Create a share from the Assets page, Collection, or Basket to share your files with others.',
  },
  emptyFilteredTitle: {
    id: 'shares.emptyFilteredTitle',
    defaultMessage: 'No shares found',
  },
  emptyFilteredDescription: {
    id: 'shares.emptyFilteredDescription',
    defaultMessage: 'Try adjusting your search or filters.',
  },
  emptyGuideStep1: {
    id: 'shares.emptyGuideStep1',
    defaultMessage:
      'Shares let you publish a branded page of selected assets with optional password protection, approvals, and expiry.',
  },
  emptyGuideStep2: {
    id: 'shares.emptyGuideStep2',
    defaultMessage:
      'Select assets on the {assetsPage}, in a collection, or in your basket, then use {withSelected} → {share} to create a new share or add to an existing one.',
  },
  emptyGuideImageAlt: {
    id: 'shares.emptyGuideImageAlt',
    defaultMessage:
      'Assets page showing the With Selected menu with Add to Share option highlighted.',
  },
  deleteConfirm: {
    id: 'shares.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this share?',
  },
  deleteSuccess: {
    id: 'shares.deleteSuccess',
    defaultMessage: 'Share deleted successfully',
  },
  copySuccess: {
    id: 'shares.copySuccess',
    defaultMessage: 'Share link copied to clipboard',
  },
  copyError: {
    id: 'shares.copyError',
    defaultMessage: 'Failed to copy link',
  },
});

